export enum CommentShared {
  WithClient = 'shared_with_client',
  WithAgent = 'shared_with_agent',
  WithConsumer = 'shared_with_consumer',
  WithCompany = 'shared_with_admin',
  // Connected closings only.
  WithLender = 'shared_with_lender',
  WithSettlementAgent = 'shared_with_settlement_agent'
}
